import { render, staticRenderFns } from "./RoleTab.vue?vue&type=template&id=a04df2bc&"
import script from "./RoleTab.vue?vue&type=script&lang=ts&"
export * from "./RoleTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QDialog})
